import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class UserPolicyConfirmationService {

  constructor(private httpClient: HttpClient) { }

  public checkUserPolicy(id: number): Observable<boolean> {
    return this.httpClient.get<boolean>(`${environment.backendApiUrl}/v1/policies/confirmations/check/` + id, httpOptions);
  }
}
